export const getReportFileName = (
  contentDisposition: string | undefined
): string | null => {
  if (!contentDisposition) {
    return null;
  }

  // RFC 5987: filename*=UTF-8''encoded-name
  const filenameStarMatch = contentDisposition.match(
    /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i
  );
  if (filenameStarMatch?.[1]) {
    try {
      // handle the case where the filename is encoded in UTF-8
      return decodeURIComponent(filenameStarMatch[1].trim().replace(/["']/g, ''));
    } catch {
      return filenameStarMatch[1].trim().replace(/["']/g, '');
    }
  }

  const filenameMatch = contentDisposition.match(/filename="?([^=";]+)"?/i);
  if (filenameMatch?.[1]) {
    return filenameMatch[1].trim();
  }

  return null;
};
